var ForgeHouseConst = {};

ForgeHouseConst.Tab_Index = {
    Equip: 1,     // 装备
	Artifact: 2,  // 符文
};

module.exports = ForgeHouseConst;